// extracted by mini-css-extract-plugin
module.exports = {"root":"video_root__F8M_E","loader":"video_loader__ZGjxf","playButton":"video_playButton__gPADq","video":"video_video__UtTVI"};